/** @type {1} */
export const V1 = 1;
/** @type {2} */
export const V2 = 2;

export const RendererType = {
  V1,
  V2,
};

/**
 * @typedef {typeof RendererType[keyof typeof RendererType]} RendererTypeValue
 */
